import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SECTIONS } from 'Pages/partnerProfile/common'

export type CommonState = {
	section: SECTIONS
	isLoading: boolean
}

const initialState: CommonState = {
	section: SECTIONS.MAIN,
	isLoading: false,
}

export namespace CommonPPNS {
	export type SetSection = PayloadAction<SECTIONS>
	export type SetIsLoading = PayloadAction<boolean>
}

export const commonPPSlice = createSlice({
	name: 'commonPP',
	initialState,
	reducers: {
		setSection: (state, action: CommonPPNS.SetSection) => {
			state.section = action.payload
		},
		setIsLoading: (state, action: CommonPPNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		clearAll: (state) => {
			state.section = SECTIONS.MAIN
			state.isLoading = false
		},
	},
})
